import interpolate from "color-interpolate";
import { useMemo } from "react";
import { Bar, BarChart, Cell, Tooltip, XAxis, YAxis } from "recharts";
const palette = interpolate([
  "rgb(0,191,191)",
  "rgb(0,255,0)",
  "rgb(255,255,0)",
  "rgb(255,127,0)",
  "rgb(191,127,63)",
  "rgb(20,20,20)",
]);
function r2(n: number) {
  return Math.round(n * 100) / 100;
}

interface HistogramProps {
  stats: any;
  height?: number;
  width?: number;
}
export const DEMHistogram = ({ stats, height = 200, width = 330 }: HistogramProps) => {
  const min = stats?.min;
  const factor = stats?.max - stats?.min;
  const h = stats?.histogram;
  const validPixels = stats?.valid_pixels;
  const histogram = useMemo(
    () =>
      h?.[0]?.map((pixels, index) => {
        const height = (h[1][index + 1] + h[1][index]) / 2;
        const f = palette((height - min) / factor);
        return { percentage: r2((pixels / validPixels) * 100), height: r2(height), color: f };
      }),
    [h, factor, validPixels, min]
  );

  if (!histogram) return null;
  return (
    <BarChart layout="vertical" width={width} height={height} data={histogram}>
      <YAxis dataKey="height" reversed domain={["dataMin", "dataMax"]} />
      <XAxis type="number" hide />
      <Tooltip
        labelFormatter={(e) => `Hoogte: ${e}m`}
        formatter={(value) => `${value}%`}
        contentStyle={{ backgroundColor: "rgba(255,255,255,.9)" }}
      />
      <Bar dataKey="percentage" name="Percentage">
        {histogram.map((entry, index) => (
          <Cell key={index} fill={entry.color} />
        ))}
      </Bar>
    </BarChart>
  );
};
